const { Fragment, useEffect } = wp.element;
const { PanelBody, PanelRow, Button, __experimentalNumberControl: NumberControl, TextControl, SelectControl, TextareaControl, ButtonGroup } = wp.components;
import { ToggleControl } from "@wordpress/components";
const { __ } = wp.i18n;

import BMediaUpload from "../../BMediaUpload";
import { isYoutubeURL } from "../../../../../../wp-utils/v1";
import BControlPro from "../../../../components/BControlPro";

const Settings = ({ attributes, setAttributes, handleOptions, handleFeatures, isPremium, name }) => {
  const { source, poster, library, protected: bProtected, password, protectedText, options, features } = attributes;

  const { autoplay, muted, hideControls, seekTime, preload, ratio, ads, playsinline, resetOnEnd, loop, urls } = options;

  const { hideYoutubeUI, playWhenVisible, disablePause, thumbInPause, sticky, startTime } = features;

  // console.log(features, options);

  useEffect(() => {
    if (isYoutubeURL(source)) {
      setAttributes({ library: "youtube" });
    }
  }, [source]);

  return (
    <PanelBody title={__("Settings", "h5vp")} initialOpen={false}>
      <BMediaUpload type={["video"]} onSelect={(source) => setAttributes({ source })} value={source} placeholder="video source" />

      <BMediaUpload
        type={["image"]}
        onSelect={(poster) => {
          setAttributes({ poster });
        }}
        value={poster}
        placeholder="video Thumbnails"
        help="thumbnail will show on frontend"
      />

      {/* <ToggleControl disabled={!isPremium} /> */}
      <BControlPro
        Component={ToggleControl}
        isPremium={isPremium}
        label={__("Custom Downlaod URL?", "h5vp")}
        id="isCDURL"
        checked={urls.enabled}
        onChange={() => handleOptions({ enabled: !urls.enabled }, "urls")}
      />

      {urls.enabled && <TextControl value={urls.download} onChange={(download) => handleOptions({ download }, "urls")} />}

      <BControlPro
        Component={ToggleControl}
        isPremium={true}
        help={autoplay ? __("muted should be enabled", "h5vp") : ""}
        label={__("Autoplay", "h5vp")}
        id="autoplay"
        checked={autoplay}
        onChange={() => handleOptions({ autoplay: !autoplay })}
      />

      <ToggleControl label={__("Muted", "h5vp")} id="muted" checked={muted} onChange={() => handleOptions({ muted: !muted })} />

      <ToggleControl label={__("Repeat", "h5vp")} id="repeat" checked={loop.active} onChange={() => handleOptions({ loop: { ...loop, active: !loop.active } })} />

      {!loop.active && <ToggleControl label={__("Reset On End", "h5vp")} id="resetOnEnd" checked={resetOnEnd} onChange={() => handleOptions({ resetOnEnd: !resetOnEnd })} />}

      <ToggleControl label={__("Auto Hide Control", "h5vp")} id="autoHideControl" checked={hideControls} onChange={() => handleOptions({ hideControls: !hideControls })} />

      <BControlPro
        isPremium={isPremium}
        Component={ToggleControl}
        label={__("Autoplay When Visible on Screen", "h5vp")}
        id="playWhenVisible"
        checked={playWhenVisible}
        onChange={() => handleFeatures({ playWhenVisible: !playWhenVisible })}
      />

      <BControlPro
        isPremium={isPremium}
        Component={ToggleControl}
        label={__("Disable Pause", "h5vp")}
        id="disablePause"
        checked={disablePause}
        onChange={() => handleFeatures({ disablePause: !disablePause })}
      />

      <BControlPro
        isPremium={isPremium}
        Component={ToggleControl}
        label={__("Allow inline playback on iOS", "h5vp")}
        checked={playsinline}
        onChange={() => handleOptions({ playsinline: !playsinline })}
      />

      <BControlPro
        isPremium={isPremium}
        Component={ToggleControl}
        label={__("Show thumbnail on pause", "h5vp")}
        id="thumbInPause"
        checked={thumbInPause.enabled}
        onChange={() => handleFeatures({ enabled: !thumbInPause.enabled }, "thumbInPause")}
      />

      {thumbInPause.enabled && poster && (
        <PanelRow>
          <label htmlFor="thumbInPause" className="label">
            {__("Thumb Style", "h5vp")}
          </label>
          <ButtonGroup>
            <Button onClick={() => handleFeatures({ type: "default" }, "thumbInPause")} className={`button ${thumbInPause.type == "default" ? "button-primary" : ""}`}>
              {__("Default", "h5vp")}
            </Button>
            <Button onClick={() => handleFeatures({ type: "custom" }, "thumbInPause")} className={`button ${thumbInPause.type == "custom" ? "button-primary" : ""}`}>
              {__("Custom", "h5vp")}
            </Button>
          </ButtonGroup>
        </PanelRow>
      )}

      <BControlPro
        isPremium={isPremium}
        Component={ToggleControl}
        label={__("Sticky On Scroll", "h5vp")}
        id="sticky"
        checked={sticky.enabled}
        onChange={() => handleFeatures({ enabled: !sticky.enabled }, "sticky")}
      />

      {sticky.enabled && (
        <SelectControl
          labelPosition="side"
          label={__("Sticky Position", "h5vp")}
          value={sticky.position}
          options={[
            { label: "Top Right", value: "top_right" },
            { label: "Bottom Right", value: "bottom_right" },
          ]}
          onChange={(position) => {
            handleFeatures({ position }, "sticky");
          }}
        />
      )}

      <BControlPro
        isPremium={isPremium}
        Component={NumberControl}
        label={__("Seek Time", "h5vp")}
        labelPosition="edge"
        isShiftStepEnabled={true}
        onChange={(seekTime) => handleOptions({ seekTime: parseInt(seekTime) })}
        shiftStep={1}
        value={seekTime}
      />

      <BControlPro
        isPremium={isPremium}
        Component={NumberControl}
        label={__("Start Time", "h5vp")}
        isShiftStepEnabled={true}
        onChange={(startTime) => handleFeatures({ startTime: parseFloat(startTime) })}
        shiftStep={1}
        step={1}
        labelPosition="side"
        value={parseFloat(startTime)}
      />

      <BControlPro
        isPremium={isPremium}
        Component={SelectControl}
        labelPosition="side"
        value={preload}
        label={__("Preload", "h5vp")}
        options={[
          { label: "none", value: "none" },
          { label: "metadata", value: "metadata" },
          { label: "auto", value: "auto" },
        ]}
        onChange={(preload) => {
          handleOptions({ preload });
        }}
      />

      <TextControl label={__("Video Ratio", "h5vp")} onChange={(ratio) => handleOptions({ ratio })} value={ratio} placeholder={"16:9"} />

      {/* <BControlPro
        isPremium={isPremium}
        Component={ToggleControl}
        label={__("Password Protected", "h5vp")}
        checked={bProtected}
        onChange={() => setAttributes({ protected: !bProtected })}
      /> */}
      {/* {bProtected && (
        <Fragment>
          <TextControl label={__("Password", "h5vp")} value={password} onChange={(password) => setAttributes({ password })} />

          <TextareaControl label={__("Protected Text", "h5vp")} value={protectedText} onChange={(protectedText) => setAttributes({ protectedText })} />
        </Fragment>
      )} */}

      {/* <PanelRow>
                          <label htmlFor="saveState" className="label">
                            {__("Save State", "h5vp")}
                          </label>
                          <FormToggle id="saveState" checked={saveState} onChange={() => setAttributes({ saveState: !saveState })} />
                        </PanelRow> */}

      <BControlPro
        isPremium={isPremium}
        Component={TextareaControl}
        label={__("Google VAST TagURL", "h5vp")}
        id="vastTag"
        value={ads.tagUrl}
        onChange={(tagUrl) => handleOptions({ ads: { ...ads, tagUrl } })}
      />

      {isYoutubeURL(source) && (
        <ToggleControl
          BControlPro
          isPremium={isPremium}
          Component={ToggleControl}
          label={__("Hide Youtube UI (Experimental, check it's working or not for you)", "h5vp")}
          id="hideYoutubeUI"
          checked={hideYoutubeUI}
          onChange={() => handleFeatures({ hideYoutubeUI: !hideYoutubeUI })}
        />
      )}
    </PanelBody>
  );
};

export default Settings;
